// Shared network utilities for monitoring connection status
export class NetworkMonitor {
  constructor() {
    this.listeners = new Set();
    this.isOnline = navigator.onLine;
    this.signalStrength = 'unknown';
    this.lastHealthCheck = null;
    
    // Set up event listeners
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  handleOnline = () => {
    this.isOnline = true;
    this.notifyListeners({ isOnline: true, signalStrength: this.signalStrength });
  };

  handleOffline = () => {
    this.isOnline = false;
    this.signalStrength = 'offline';
    this.notifyListeners({ isOnline: false, signalStrength: 'offline' });
  };

  updateSignalStrength(strength, healthData) {
    this.signalStrength = strength;
    this.lastHealthCheck = healthData;
    this.notifyListeners({ 
      isOnline: this.isOnline, 
      signalStrength: strength,
      healthData: healthData 
    });
  }

  subscribe(callback) {
    this.listeners.add(callback);
    // Immediately notify new subscriber of current status
    callback({ 
      isOnline: this.isOnline, 
      signalStrength: this.signalStrength,
      healthData: this.lastHealthCheck 
    });
    
    return () => this.listeners.delete(callback);
  }

  notifyListeners(status) {
    this.listeners.forEach(callback => callback(status));
  }

  getStatus() {
    return {
      isOnline: this.isOnline,
      signalStrength: this.signalStrength,
      healthData: this.lastHealthCheck
    };
  }

  // Check if connection is good enough for processing
  isConnectionStable() {
    return this.isOnline && this.signalStrength !== 'bad' && this.signalStrength !== 'offline';
  }

  destroy() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
    this.listeners.clear();
  }
}

// Singleton instance
export const networkMonitor = new NetworkMonitor(); 